import castArray from 'lodash-es/castArray'
import get from 'lodash-es/get'
import uniq from 'lodash-es/uniq'
import * as React from 'react'

import { IItemCard } from '../interface'

import * as styles from './lockupFilesIncluded.module.css'

const LockupFilesIncluded = ({ item }: IItemCard) => {
  const { attributes } = item

  const filesAttribute = attributes.find(
    attr =>
      attr.name.includes('files-included') ||
      attr.name.includes('formats-included') ||
      attr.name.includes('file-format')
  )

  const fileTypes = get(filesAttribute, 'value') || []

  const attributeNames = {
    'Photoshop PSD': 'PSD',
    'InDesign INDD': 'INDD',
    'Quark QXP': 'QXP',
    'Vector EPS': 'EPS',
    'JPG Image': 'JPG',
    'AI Illustrator': 'AI',
    'TIFF Image': 'TIFF',
    'Photoshop ABR': 'ABR',
    'Photoshop GRD': 'GRD',
    'Photoshop PAT': 'PAT',
    'Photoshop ASL': 'ASL',
    'Photoshop ATN': 'ATN',
    'Photoshop CSH': 'CSH',
    'Photoshop HDR': 'HDR',
    'Photoshop JSX': 'JSX',
    'ZXP file': 'ZXP',
    '.3b (3dcoat)': '3B',
    '.3ds (multi format)': '3DS',
    '.blend (blender)': 'BLEND',
    '.c4d (cinema 4d)': 'C4D',
    '.dwg (AutoCAD)': 'DWG',
    '.dxf (multi format)': 'DXF',
    '.e3d (Element 3d)': 'E3D',
    '.fbx (multi format)': 'FBX',
    '.hrc (softimage)': 'HRC',
    '.lw (lightwave)': 'LW',
    '.lwo (lightwave)': 'LWO',
    '.lws (lightwave)': 'LWS',
    '.lxo (modo)': 'LXO',
    '.ma (maya)': 'MA',
    '.max (3ds Max)': 'MAX',
    '.mb (maya)': 'MA',
    '.obj (multi format)': 'OBJ',
    '.unitypackage (Unity3D)': 'UNITYPACKAGE',
    '.vob (Vue)': 'VOB',
    '.vue (Vue)': 'VUE',
    '.xsi (softimage)': 'XSI',
    '.ztl (zbrush)': 'ZTL',
    'High Dynamic Range HDR': 'HDR',
    '.bip': 'BIP',
    '.bvh': 'BVH',
    '.csm': 'CSM',
    '.mel': 'MEL',
    '.exe': 'EXE',
    '.mse': 'MSE',
    '.mcr': 'MCR',
    '.ms': 'MS'
  }

  if (!fileTypes || !fileTypes.length) {
    return null
  }

  return (
    <>
      <span className={styles.label}>File Types Included:</span>
      <ul>
        {uniq(castArray(fileTypes)).map((fileType, index) => (
          <li className={styles.fileType} key={index}>
            {get(attributeNames, fileType, fileType)}
          </li>
        ))}
      </ul>
    </>
  )
}

export default LockupFilesIncluded
